import { useParams } from 'react-router-dom'
import { useLocale } from '../i18n/context'

export default function GrammarArticlePage() {
  const { slug } = useParams()
  const { tr } = useLocale()
  return (
    <div>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: 'var(--text-primary)', letterSpacing: '-0.02em' }}>
        {tr.grammarArticle.title}
      </h1>
      <p style={{ color: 'var(--text-secondary)', marginTop: 8 }}>Slug: {slug}</p>
    </div>
  )
}
